import { isNilOrEmpty } from 'ramda-adjunct';

export const toTitleCase = (string: string) => {
  if (isNilOrEmpty(string)) return 'Undefined';
  return string[0].toUpperCase() + string.slice(1);
};

export const booleanToText = (value: boolean) => (value ? 'Oui' : 'Non');
